<template>
  <div id="app">
    <AppHeader />

    <!-- Didn't bother making this a component since it has no logic -->
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <h1 class="d-none d-sm-block display-4">Greenock Chinese Takeaway!</h1>
        <h1 class="d-sm-none">Greenock Chinese Takeaway!</h1>

        <p class="lead">
          Check out our latest menu items below
          <br />We ask all customers to call and <u>order in advance</u> for
          best service.
        </p>
        <hr class="my-4" />
        <p class="lead pb-2">You can browse our online menu :</p>
        <p class="lead">
          <button
            id="see-menu-clicked"
            v-scroll-to="'.pill-bar'"
            class="menu-btn"
            type="button"
            @click.prevent="handleMenuClickEvent"
          >
            See menu
          </button>
        </p>
      </div>
    </div>

    <PillBar />

    <!-- This holds the menu and search/filtered results -->
    <div id="main" class="container pt-4 pb-4">
      <router-view class="router-class"></router-view>
    </div>

    <div class="cta-box">
      <h5>Main dishes comes with boiled rice for 20p.</h5>

      <p class="mt-1 mb-1">Extra 50p for fried rice or chips.</p>
    </div>

    <footer class="sp-4 my-md-5 pt-md-1 border-top">
      <div class="p-2 row">
        <div class="pb-4 col-12 col-md">
          <img
            class="mb-2 pr-3"
            src="./assets/hs_logo.svg"
            alt="Highland Star - Chinese Takeaway in Greenock - Logo"
            height="60"
          />
          <a
            class="mb-2"
            href="https://ratings.food.gov.uk/business/en-GB/259/New-Highland-Star-Inverclyde"
            target="_blank"
          >
            <img src="./assets/FSA_pass.jpeg" alt height="60" />
          </a>
          <small class="d-block mb-3 text-muted">&copy; 2020-2021</small>
          <a
            class="mr-2"
            style="color: #3b5998"
            href="https://www.facebook.com/Highland-Star-Greenock-101961248190563/?view_public_for=101961248190563"
            target="_blank"
          >
            <i class="fab fa-facebook-square fa-4x"></i>
          </a>
          <a
            style="color: #db4437"
            href="https://g.page/Highland_star?we"
            target="_blank"
          >
            <i class="fab fa-google-plus-square fa-4x"></i>
          </a>
        </div>
        <div class="col-12 col-md">
          <h5><i class="fas fa-book-open"></i> About</h5>
          <p>
            We're a small family-owned Chinese takeaway business based in
            Greenock since 1997. It's hard to believe that it's almost been 24
            years and we only just set up our first facebook page!
            <b>LIKE</b> us on facebook!
          </p>
        </div>

        <div class="col-12 col-md">
          <h5><i class="fas fa-map-marker-alt"></i> Address</h5>
          <p class="text-muted text-small">
            39 Regent Street,
            <br />PA15 4PL, <br />Greenock, <br />Inverclyde
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader";
import PillBar from "./components/PillBar";
import { mixpanel } from "./main";

export default {
  name: "App",
  components: {
    AppHeader,
    PillBar,
  },
  mounted() {
    mixpanel.track("Homepage View");
  },
  methods: {
    handleMenuClickEvent(e) {
      // Prevent multiple clicks and event logs by disabling button by 0.5s
      e.target.disabled = true;
      mixpanel.track(`Clicked See Menu`);
      setTimeout(() => (e.target.disabled = false), 500);
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

h1 {
  font-family: "Montserrat";
}

hr {
  width: 60%;
  border-top: 1px solid white;
  margin-left: 0;
}

footer {
  z-index: -10;
}

.lead {
  font-weight: 500;
}

.router-class {
  display: inline-block;
}

.container {
  width: 80%;
  display: inline-block;
}

.cta-box {
  position: fixed;
  bottom: 40%;
  color: white;
  padding: 10px;
  margin-right: 30px;
  text-align: center;
  display: inline-block;
  background: rgb(22, 86, 36);
  border: rgb(22, 86, 36);
  border-style: solid;
  border-radius: 5px;
  z-index: -1;
}

.menu-btn {
  background-color: green;
  color: white;
  --height: 2.5em;
  height: 2.5em;
  width: auto;
  padding: 0.5em 1.5em 0.5em;
  border-width: 0;
  border-radius: calc(var(--height) / 2);
  text-align: center;
  font-weight: 500;
  cursor: pointer;
}

.menu-btn:hover {
  background-color: rgb(0, 182, 0);
}

.jumbotron {
  min-height: 100vh;
  color: white;
  background-image: url("./assets/jumbotron-down-sized.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0;
}

@media screen and (max-width: 767px) {
  /* makes the container full-width on mobile */
  .container {
    width: 100%;
  }
  /* cta-box is hidden on mobile and above container is made full-width*/
  .cta-box {
    display: none;
  }

  hr {
    width: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .jumbotron {
    background-position: 40% 0%;
  }
}
</style>
